module.exports = "../images/fishing-lodge-20.jpg?v=8711e4c";